import React, { useEffect, useState } from "react";
import {NavLink} from "react-router-dom"; // Import NavLink from react-router-dom
import SidebarLogo from "../../common/assets/svg/sidebarlogo.svg";
import AutoGrouper from "../../assets/plusNew.png";
import Codie from "../../assets/conversationznew.png";
import Admin from "../../assets/settingNotFill.png";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Sidebar/Sidebar.css";
import { navigationTree } from "./Service";
import { BiLoader } from "react-icons/bi";
import { useAuth } from "../../authContext/AuthContext";
import axiosInstance from "../../axiosinterceptor";
import CodeAssist from "../../assets/bookNew.png";
import Codeaccelerate from "../../assets/icons8-rocket-64.png";
import CodePlusIcon from "../../common/assets/images/codeplusIcon.png"
import Codeworkflow from "../../assets/menuNew.png";
import Settings from "../../assets/settingsNew.png";
import settings_icon from "../../common/assets/images/settings.png";
import logoutIcon from "../../assets/logoutPNG.png";
import { CircleImg } from "../../common/assets/svg/CircleBlack";
import { ArrowDown } from "../../common/assets/svg/ArrowBlack";
import ArrowRight from "../../common/assets/svg/ArrowRight";
import {
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  useMediaQuery,
  Box,
  Grid,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useTheme } from "@mui/material/styles";
import { clearCodebookFromIndexedDB } from "../../utils/indexedDB";
import { removeCode } from "../CodingScreen/Service";
 
const Sidebar = ({sidebarOpen,setSidebarOpen}) => {
  const { userEmail } = useAuth();
  const theme = useTheme();
  const [openMenus, setOpenMenus] = useState({});
  const [navigationItems, setNavigationItems] = useState();
  const [loading, setLoading] = useState(false);
  const name = String(userEmail)?.split("@")[0];
  const [error, setError] = useState("");
  // const permissions = JSON.parse(sessionStorage.getItem("permissions"));
  const userId = sessionStorage.getItem("userId");
  const [mobileOpen, setMobileOpen] = useState(false);
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [hideIcons, setHideIcons] = useState(false);
  // Toggle function to open/close submenus
const toggleMenu = (header) => {
  setOpenMenus((prev) => {
    const isCurrentlyOpen = prev[header];
    // Close all menus first
    const newState = {};
    Object.keys(prev).forEach((key) => {
      newState[key] = false;
    });
    // Toggle the clicked one
    newState[header] = !isCurrentlyOpen;
    return newState;
  });
};

    useEffect(() => {
    navigationTree()
      .then((items) => {
        const initialMenus = {};
        items.forEach((route) => {
          initialMenus[route.main_Router] = false; // Start with all menus closed
        });
        setOpenMenus(initialMenus);
        setNavigationItems(items);
      })
      .catch((error) => {
        console.error("Failed to fetch navigation items:", error);
        setError("Failed to load navigation");
      });
  }, []);
  const handleSidebarToggle = () => {
    setSidebarOpen((prev) => !prev);
  };
  const handleDrawerToggle = () => {
    // setMobileOpen(!mobileOpen);
    setMobileOpen((prev) => !prev);
  };
  // Function to get image source based on the header
  const getImageSource = (header) => {
    switch (header) {
      case "Code Workflow":
        return Codeworkflow;
      case "Code Accelerate":
        return Codeaccelerate;
      case "Code Assist":
        return CodeAssist;
      case "Code Enhance":
        return AutoGrouper;
      case "Codie":
        return Codie;
      case "Admin":
        return Admin;
      case "Settings":
        return Settings;
      case "Settings":
        return settings_icon;
      case "Code Enhance Plus":
        return CodePlusIcon;
      default:
        return "";
    }
  };
  // useEffect(() => {
  //   navigationTree().then((items) => {
  //    setNavigationItems(items);
  //   });
  // }, []);
const callRemoveCode = async () => {
  const hcpLineId = sessionStorage.getItem("last_hcp_line_id");
  const alreadyConfirmed = sessionStorage.getItem("isConfirmed") === "true";

  if (!hcpLineId) return;

  if (
    (!JSON.parse(sessionStorage.getItem("initialprincipalDiagnosisState")) &&
      !JSON.parse(sessionStorage.getItem("initialadditionalDiagnosisState")) &&
      !JSON.parse(sessionStorage.getItem("initialprocedureDiagnosisState"))) ||
    alreadyConfirmed
  ) {
    return;
  }

  try {
    await removeCode({
      hcp_line_id: hcpLineId,
      principal_diagnosis_code:
        JSON.parse(sessionStorage.getItem("initialprincipalDiagnosisState")) || [],
      additional_diagnosis_codes:
        JSON.parse(sessionStorage.getItem("initialadditionalDiagnosisState")) || [],
      procedure_codes:
        JSON.parse(sessionStorage.getItem("initialprocedureDiagnosisState")) || [],
    });

    sessionStorage.removeItem("initialprincipalDiagnosisState");
    sessionStorage.removeItem("initialadditionalDiagnosisState");
    sessionStorage.removeItem("initialprocedureDiagnosisState");

  } catch (error) {
    console.error("Remove code API failed:", error);
  }
};

const handleLogoutClick = async () => {
    sessionStorage.removeItem("initialprincipalDiagnosisState");
  sessionStorage.removeItem("initialadditionalDiagnosisState");
  sessionStorage.removeItem("initialprocedureDiagnosisState");
  setLoading(true);
  sessionStorage.removeItem("initialprincipalDiagnosisState");
  sessionStorage.removeItem("initialadditionalDiagnosisState");
  sessionStorage.removeItem("initialprocedureDiagnosisState");

  try {
    await callRemoveCode();

    const postapiEndpoint = "";
    const accessToken = sessionStorage.getItem("accessToken");
    const postpayload = {
      body: {
        session_token: accessToken,
      },
    };

    if (postapiEndpoint) {
      await axiosInstance.post(postapiEndpoint, postpayload);
    }

    await clearCodebookFromIndexedDB();

    sessionStorage.removeItem("isFetched12");
    sessionStorage.removeItem("isFetched13");
    sessionStorage.clear();

    window.location.reload();
  } catch (error) {
    console.log("Error in logout request:", error);
    setError(error.message);
  } finally {
    setLoading(false);
  }
};

// const handleLogoutClick = async () => {
//   try {
//     setLoading(true);
 
//     const accessToken = sessionStorage.getItem("accessToken");
//     const postpayload = { body: { session_token: accessToken } };
//     const postapiEndpoint = ""; // currently unused
 
//     if (postapiEndpoint) {
//       await axiosInstance.post(postapiEndpoint, postpayload);
//     }
 
//     // 🔹 Delete the entire IndexedDB before reload
//     await clearCodebookFromIndexedDB();
 
//     // 🔹 Clear other storages
//     sessionStorage.removeItem("isFetched12");
//     sessionStorage.removeItem("isFetched13");
//     sessionStorage.clear();
 
//     console.log("✅ All caches cleared, reloading...");
//     window.location.reload();
//   } catch (error) {
//     console.error("Error in logout process:", error);
//     setError(error.message);
//   } finally {
//     setLoading(false);
//   }
// };
 
 
  const handleMobileSidebarToggle = () => {
    // setIsMobile(true);
    setHideIcons(true);
    setSidebarOpen((prev) => !prev);
  };
  const drawerContent = (
    <>
      <Box
        className="w-10 text-white"
        sx={{
          backgroundColor: "#f2f6fc",
          height: "100%",
          overflow: "hidden",
        }}
      >
        <Box>
          <Box>
            <Box className="sidebar-wrapper-notification">
              <img className="p-3" src={SidebarLogo} alt="sidebarlogo" />
            </Box>
            <Box className="sidebar-navigation-container">
              <List className="sidebar-companion-toggle-btn">
                {/* Map through the parent items in the configData */}
                {navigationItems?.map((route, index) => (
                  <ListItem key={index}>
                    {/* Parent Item */}
                    <Box
                      onClick={() => toggleMenu(route.main_Router)}
                      sx={{
                        fontSize: "10px !important",
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "10px !important",
                      }}
                    >
                      <Box>
                        <img
                          src={getImageSource(route.main_Router)}
                          style={{
                            width: "20px",
                            height: "20px",
                            marginRight: "10px",
                          }}
                          alt="imgsrc"
                        />
                      </Box>
                      {/* If no children, navigate directly */}
                      {/* {route?.children ? (
                          <NavLink to="#">{route.main_Router}</NavLink>
                        ) : (
                          <NavLink to={`/${route.main_Router.toLowerCase()}`}>
                            {route.main_Router}
                          </NavLink>
                        )} */}
                      {route.path &&
                        (!route.children || route.children.length === 0) ? (
                        <NavLink
                          to={`/${route.path}`}
                          style={{
                            color: "#606770",
                            display: "inline-block",
                            paddingRight: "10px",
                            fontWeight: "bolder",
                            fontSize: "12px",
                          }}
                          onClick={() => {
                            if (
                              !route.children ||
                              route.children.length === 0
                            ) {
                              setMobileOpen(false); // or your state setter
                            }
                          }}
                        >
                          {route.main_Router}
                        </NavLink>
                      ) : route?.children && route.children.length > 0 ? (
                        <NavLink
                          to="#"
                          style={{
                            color: "#606770",
                            display: "inline-block",
                            paddingRight: "10px",
                            fontWeight: "bolder",
                            fontSize: "12px",
                          }}
                        >
                          {route.main_Router}
                        </NavLink>
                      ) : (
                        <NavLink
                          to={`/${route.main_Router.toLowerCase()}`}
                          style={{
                            color: "#606770",
                            display: "inline-block",
                            paddingRight: "10px",
                            fontWeight: "bolder",
                            fontSize: "12px",
                          }}
                        >
                          {route.main_Router}
                        </NavLink>
                      )}
                    </Box>
                    {/* Child Items: Toggle visibility based on parent item state */}
                    {openMenus[route?.main_Router] && route?.children && (
                      <List>
                        {/* Map through child items and render NavLinks */}
                        {route?.children.map((child, idx) => (
                          <ListItem key={idx}>
                            {/* {console.log(child.path)} */}
                            {child?.name=="Demo"?
                            <a target="_blank" rel="noopener noreferrer" href={child?.path}
                            style={{
                                fontSize: "15px",
                                color: "#606770",
                                display: "inline-block",
                                paddingRight: "10px",
                                fontWeight: "500",
                                fontSize: "12px",
                              }}>{child?.name}s{" "}</a>:<NavLink
                              to={child?.path}
                              style={{
                                fontSize: "15px",
                                color: "#606770",
                                display: "inline-block",
                                paddingRight: "10px",
                                fontWeight: "500",
                                fontSize: "12px",
                              }}
                              onClick={() => setMobileOpen(false)}
                            >
                              {child?.name}
                            </NavLink>}{" "}
                            {/* Child items are clickable */}
                          </ListItem>
                        ))}
                      </List>
                    )}
                  </ListItem>
                ))}
              </List>
              <Box className="user-details-container position-absolute bottom-0 w-100">
                <Box className="user-details">
                  <Box className="user-icon-name-row">
                    {" "}
                    {/* New wrapper for icon and name */}
                    <Box className="user-icon">
                      <CircleImg />
                    </Box>
                    <Tooltip title={name}>
                      <Box className="user-name">
                        {name.length > 10 ? `${name.slice(0, 10)}...` : name}
                      </Box>
                    </Tooltip>
                    <Box>
                      <Box className="landingpage-arrow-down">
                        <ArrowDown />
                        <Box className="landingpage-dropdown-content">
                          <Box className="d-flex gap-2 flex-column">
                            <Box
                              className="landing-logout-btn"
                              onClick={handleLogoutClick}
                            >
                              <ArrowRight />
                              {loading ? <BiLoader /> : "Logout"}
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                  <Box className="user-email-row">
                    {" "}
                    {/* New wrapper for email and arrow */}
                    <Tooltip title={userEmail}>
                      <Box className="user-email">{userEmail}</Box>
                    </Tooltip>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
  return (
    <>
      {isSmallScreen && (
        <>
          <AppBar position="fixed" className="sidebar-mobile-wrapper">
            <Toolbar>
              <IconButton
                color="inherit"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{ mr: 2 }}
              >
                <MenuIcon />
              </IconButton>
              <img
                src={SidebarLogo}
                alt="Sidebar Logo"
                style={{ height: 40 }}
              />
            </Toolbar>
          </AppBar>
          <Box component="nav">
            <Drawer
              variant={isSmallScreen ? "temporary" : "permanent"}
              open={isSmallScreen ? mobileOpen : true}
              onClose={handleDrawerToggle}
              ModalProps={{ keepMounted: true }} // better mobile performance
              sx={{
                "& .MuiDrawer-paper": {
                  boxSizing: "border-box",
                  width: 250,
                },
              }}
            >
              {drawerContent}
            </Drawer>
          </Box>
        </>
      )}
      {!isSmallScreen && (
        <>
          <div
            className="transition-all duration-100"
            style={{ width: sidebarOpen ? "200px" : "100px" }}
          >
            <div className="main-sidebar position-relative">
              <div>
                {/* Sidebar Logo: Click to toggle sidebar */}
                <div className="sidebar-wrapper-notification">
                  <img className="p-3" src={SidebarLogo} alt="sidebarlogo" />
                </div>
                {/* Navigation Items */}
                <div className="sidebar-navigation-container">
                  <ul
                    className="sidebar-companion-toggle-btn"
                    style={{ paddingLeft: sidebarOpen ? "16px" : "32px" }}
                  >
                    {navigationItems
                      ?.filter((route) => route.main_Router !== "Admin")
                      ?.map((route, index) => (
                        <li key={index}>
                          {/* Parent Item (click to toggle submenu) */}
                          <div
                            // onClick={() => toggleMenu(route.main_Router)}
                            style={{ cursor: "pointer" }}
                          >
                            <div className="d-flex align-items-center">
                              <Tooltip
                                title={!sidebarOpen && route.main_Router}
                                placement="right"
                                arrow
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      fontSize: "14px", // Change this to your desired size
                                    },
                                  },
                                }}
                              >
                                <img
                                  className="nav-icon"
                                  src={getImageSource(route.main_Router)}
                                  style={{ width: "28px", height: "28px" }}
                                  // onClick={handleSidebarToggle}
                                  onClick={() => {
                                    if (sidebarOpen) {
                                      setSidebarOpen(false); // Just collapse, no submenu change
                                    } else {
                                      setSidebarOpen(true);
                                      setOpenMenus((prev) => ({
                                        ...prev,
                                        [route.main_Router]: true, // Force open submenu
                                      }));
                                    }
                                  }}
                                  alt="imgsrc"
                                />
                              </Tooltip>
                              {/* Show text only if sidebar is open */}
                              {sidebarOpen && (
                                <NavLink
                                  to={route.path ? `/${route.path}` : "#"}
                                  className="text-decoration-none"
                                 onClick={(e) => {
                                    if (route.children && route.children.length > 0) {
                                      e.preventDefault(); // Prevent # navigation
                                      toggleMenu(route.main_Router);
                                    } else {
                                      setSidebarOpen(false);
                                    }
                                  }}
                                >
                                  {route.main_Router}
                                </NavLink>
                              )}
                            </div>
                          </div>
                          {/* Child Items: Show only when sidebar is open and submenu toggled */}
                          {sidebarOpen &&
                            openMenus[route?.main_Router] &&
                            route?.children && (
                              <ul>
                                {route?.children.map((child, idx) => (
                                  <li
                                    key={idx}
                                    className="ps-4"
                                    onClick={() => setSidebarOpen(false)}
                                  >
                                    {child?.name =="Demo"?
                                    <a target="_blank" rel="noopener noreferrer" href={child?.path} className="text-decoration-none" >{child?.name}</a>:<NavLink
                                      to={child?.path}
                                      className="text-decoration-none"
                                    >
                                      {child?.name}
                                    </NavLink>}
                                  </li>
                                ))}
                              </ul>
                            )}
                        </li>
                      ))}
                  </ul>
                  <div
                    className="user-details-container position-absolute bottom-0 w-100"
                    style={{
                      justifyContent: !sidebarOpen && "center",
                      paddingLeft: sidebarOpen && "16px",
                    }}
                  >
                    {navigationItems
                      ?.filter((route) => route.main_Router === "Admin")
                      .map((route, index) => (
                        <div key={index}>
                          <div style={{ cursor: "pointer" }}>
                            <span onClick={handleSidebarToggle}>
                              <Tooltip
                                title={!sidebarOpen && route.main_Router}
                                placement="right"
                                arrow
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      fontSize: "14px", // Change this to your desired size
                                    },
                                  },
                                }}
                              >
                                <img
                                  src={Admin}
                                  style={{ width: "28px", height: "28px" }}
                                  alt="admin-icon"
                                  className="admin-icon"
                                />
                              </Tooltip>
                            </span>
                            {route.path ? (
                              <NavLink to={`/${route.path}`}>
                                {route.main_Router}
                              </NavLink>
                            ) : (
                              <NavLink
                                onClick={() => setSidebarOpen(false)}
                                to={`/${route.main_Router.toLowerCase()}`}
                              >
                                {sidebarOpen && route.main_Router}
                              </NavLink>
                            )}
                          </div>
                        </div>
                      ))}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                      }}
                    >
                      <Tooltip
                        title="Logout"
                        placement="right"
                        arrow
                        componentsProps={{
                          tooltip: {
                            sx: {
                              fontSize: "14px", // Change this to your desired size
                            },
                          },
                        }}
                      >
                        <img
                          src={logoutIcon}
                          alt="logout"
                          style={{ height: "28px" }}
                          onClick={handleLogoutClick}
                        />
                      </Tooltip>
                      {sidebarOpen && (
                        <span
                          style={{
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: "#000000",
                          }}
                          onClick={handleLogoutClick}
                        >
                          Logout
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default Sidebar;